import { CreatePrimitiveDepsKey } from "./types";

export const createPrimitiveDepsKey: CreatePrimitiveDepsKey = (deps) => {
  if (!deps?.length) {
    return "";
  }

  return deps.map((v) => `${typeof v}:${String(v)}`).join("|");
};
